.thumb {
    display: flex;
    flex-direction: column;
    min-height: 254px;
    padding: 20px 24px;
    background-color: white;
    border: 1px solid #e3e6eb;
    border-radius: 8px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: background-color 0.2s ease;
    &:hover {
        background-color: #e8f0fe;
    }
}

.divider {
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #e0e0e0;
    margin-bottom: 15px;
}

.title {
    font-size: 22px;
    line-height: 1.3;
    font-family: Hanken Grotesk;
    font-weight: 600;
    color: #102442;
    text-align: center;
}

.filenameText {
    font-size: 16px;
    line-height: 1.3;
    font-family: Hanken Grotesk;
    font-weight: 600;
    color: #475467;
    text-align: center;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
}
